import script from "./Writer.vue?vue&type=script&setup=true&lang=ts&name=ContractCURD"
export * from "./Writer.vue?vue&type=script&setup=true&lang=ts&name=ContractCURD"

const __exports__ = script;

export default __exports__